<template>
  <BlockFieldset class="project-bank-employment-income">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <div v-else>
      <div class="bank-section-grid bank-section-grid--paired">
        <template v-for="row in ATTACHMENT_ROWS">
          <div class="label" :key="`${row.attachmentType}-label`">{{ $t(row.labelKey) }}</div>
          <div :key="row.attachmentType">
            <BankAttachmentUpload
              :project="project"
              :attachmentType="row.attachmentType"
              @changed="reloadBlock"
            />
          </div>
        </template>
      </div>
    </div>
  </BlockFieldset>
</template>

<script>
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import BankAttachmentUpload from '@/components/Projects/BankAttachmentUpload';
import { BANK_ATTACHMENT_TYPES } from '@/helpers/bankAttachmentTypes';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { ProjectBankBlockMixin } from '@/mixins/projectBankBlock';
import { PROJECT_BANK_EMPLOYMENT_INCOME_FIELDS } from './projectBankEmploymentIncomeFragment';

/** Documents of the section in the order of the previous tab. */
const ATTACHMENT_ROWS = [
  {
    labelKey: 'bankAttachmentIncomeTaxAssessment',
    attachmentType: BANK_ATTACHMENT_TYPES.BANK_INCOME_TAX_ASSESSMENT,
  },
  {
    labelKey: 'bankAttachmentIncomeTaxReturn',
    attachmentType: BANK_ATTACHMENT_TYPES.BANK_INCOME_TAX_RETURN,
  },
  {
    labelKey: 'bankAttachmentDecemberPayslip',
    attachmentType: BANK_ATTACHMENT_TYPES.BANK_DECEMBER_PAYSLIP,
  },
  {
    labelKey: 'bankAttachmentCurrentPayslip',
    attachmentType: BANK_ATTACHMENT_TYPES.BANK_CURRENT_PAYSLIP,
  },
];

/**
 * Block project-bank-employment-income ("Einkommen / Lohn / Gehalt", tab Bank, see feature page projekt-bank): the documents of the section.
 * `project` is the block data (`Project.blocks.bankEmploymentIncome`); an upload or a delete reloads it. On
 * the unsaved project it shows only a hint.
 */
export default {
  name: 'ProjectBankEmploymentIncome',
  components: { BankAttachmentUpload, BlockFieldset },
  mixins: [AccessBlockMixin, ProjectBankBlockMixin],
  bankBlockField: 'bankEmploymentIncome',
  bankBlockFragment: PROJECT_BANK_EMPLOYMENT_INCOME_FIELDS,
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return { ATTACHMENT_ROWS };
  },
};
</script>

<style scoped lang="scss">
@import '../../styles/bankSectionGrid';
</style>
